import { Redirect } from 'react-router-dom';

import ProfileCreation from '../core/profile-creation/pages/profile-creation';
import ProfileInvitation from '../core/profile-creation/pages/profile-invitation';
import ProfileCreationBlocked from '../core/profile-creation/pages/profile-creation-blocked';

import { PROFILE_CREATION_PATH, COMMON_PATH } from './paths';
import { CommonRoute, ProfileCreationRoute } from './interfaces';

// Redirection
export const redirectRoute: CommonRoute = {
  render: () => <Redirect to={COMMON_PATH.HOME} />,
  isRedirect: true
};

const createProfileRoute: ProfileCreationRoute = {
  path: PROFILE_CREATION_PATH.PROFILE_CREATION,
  render: () => <ProfileCreation />
};

const profileCreationBlockedRoute: ProfileCreationRoute = {
  path: PROFILE_CREATION_PATH.PROFILE_CREATION_BLOCKED,
  render: () => <ProfileCreationBlocked />
};

const userInvitedRoute: ProfileCreationRoute = {
  path: PROFILE_CREATION_PATH.USER_INVITED,
  render: () => <ProfileInvitation />
};

const profileCreationRoutes: ProfileCreationRoute[] = [
  createProfileRoute,
  profileCreationBlockedRoute,
  userInvitedRoute
];

export const getProfileCreationRoutes = (): (ProfileCreationRoute | CommonRoute)[] => [
  ...profileCreationRoutes,
  redirectRoute
];

export const isProfileCreationRoute = (route: any): boolean =>
  profileCreationRoutes.some(profileCreationRoute => route.includes(profileCreationRoute.path));
